import { useRef } from 'react';

// this hook allows app to reference and set focus to an element
export default function useFocus() {
  const htmlElRef = useRef(null);
  const setFocus = () => {
    setTimeout(() => {
      if (htmlElRef && htmlElRef.current) {
        htmlElRef.current.focus();
      }
    }, 0);
  };

  return [htmlElRef, setFocus];
}
